import Piano from '../piano/piano.js';

class GoogleOfferwall {
	maybeActivateOfferwall() {
		window.googlefc = window.googlefc || {};
		window.googlefc.controlledMessagingFunction = (message) => {
			// Not on a premium article, don't show
			if (!Piano.isPremiumArticle()) {
				message.proceed(false, [window.googlefc.MessageTypeEnum.OFFERWALL]);
				return;
			}

			// No user is logged in, show
			if (!Piano.isUserValid()) {
				message.proceed(true);
				return;
			}

			// No ad type cookie, show
			const cookie = Piano.getAdTypeCookie();
			if (!cookie) {
				message.proceed(true);
				return;
			}

			// If the cookie is set to no_content_ads or no_ads this is a premium user, show
			if (cookie === 'no_content_ads' || cookie === 'no_ads') {
				message.proceed(false, [window.googlefc.MessageTypeEnum.OFFERWALL]);
				return;
			}
		};
	}

	addOfferwallEventListeners() {
		googletag = window.googletag || { cmd: [] };
		googletag.cmd.push(function () {
			googletag.pubads().addEventListener('rewardedSlotGranted', function () {
				Piano.loadPremiumContentAfterAdView(window.bi_piano.post_id);
			});
		});
	}
}

const instance = new GoogleOfferwall();
export default instance;
